import React from 'react';
import AccessRestrictedImg from '../../assets/target/images/AccessRestrictedImg.png';
import PageHeader from '../../components/PageHeader';
import AppConfig from '../../config';
import { t } from '../../lang';

import './AccessRestricted.scss';

const { name } = AppConfig;

const AccessRestricted = () => {
	return (
		<div className='AccessRestricted'>
			<PageHeader />
			<div className='AccessRestricted__body'>
				<img className='AccessRestricted__img' src={AccessRestrictedImg} />

				<div className='RecoveryPassword__title'>{t('Access restricted')}</div>
				<div className='RecoveryPassword__text'>
					{t(
						'Your current location is included in the list of restricted countries configured by the Administrator (root).'
					)}
				</div>
			</div>
		</div>
	);
};

export default AccessRestricted;
